module.exports = __webpack_public_path__ + "static/media/btc_deposit_icon.a63a6b5f.svg";